import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ActivityCardComponent } from '../activity-card/activity-card.component';
import { ProductService } from 'src/app/core/api/product/product.service';
import { RewardService } from 'src/app/core/api/reward/reward.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { SnackBarService } from 'src/app/core/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { CouponCardService } from 'src/app/core/services/coupon-card/coupon-card.service';

@Component({
  selector: 'app-coupon-card-vip',
  templateUrl: './coupon-card-vip.component.html',
  styleUrls: ['./coupon-card-vip.component.scss'],
})
/**
 * Instantiates warranty card as a coupon
 */
export class CouponCardVipComponent extends ActivityCardComponent {
  @Input() resellerName?: string;
  @Input() codeVip?: string;
  @Input() discount?: number;
  @Input() startingDate?: string;
  models!: any;
  uniqueModel!: any;

  /**
   * @constructor
   * @param {ProductService} productService
   * @param {RewardService} rewardService
   * @param {TranslationService} translationService
   * @param {SnackBarService} snackbarService
   * @param {ChangeDetectorRef} changeDetector
   * @param {Router} router
   * @param {CouponCardService} couponCardService
   */
  constructor(
    productService: ProductService,
    rewardService: RewardService,
    translationService: TranslationService,
    snackbarService: SnackBarService,
    changeDetector: ChangeDetectorRef,
    router: Router,
    couponCardService: CouponCardService
  ) {
    super(
      rewardService,
      productService,
      translationService,
      snackbarService,
      changeDetector,
      router,
      couponCardService
    );
  }

  /**
   * on init
   */
  override ngOnInit(): void {
    this.uniqueModel = '';
    this.productService
      .getBusinessEquipments(this.businessId!)
      .subscribe((equipments) => {
        this.models = equipments.map((obj) => obj.planModel);
        this.findModel();
      });

    this.startingDate = this.translationService.localizeDate(
      this.startingDate!
    );
  }

  /**
   * Find Model that has discount
   */
  findModel(): void {
    if (!this.models || this.models.length === 0) return;

    const model = this.models[0];
    const modelArray = model.split(' ');

    this.uniqueModel = 'SERIES-' + modelArray[1].substring(0, 1) + ' INK';
  }
}
